'use client';

import Link from 'next/link';
import { useLocale } from 'next-intl';
import type React from 'react';

import { ShowingDto } from '@cineamo/api/models/showing/ShowingDto.types';

import { CachedContentData } from '@/hooks/useCachedContentData';
import { useFormat } from '@cineamo/ui/src/hooks/formatter/useFormat';

import { IconExternalLink16 } from '@cineamo/ui/src/icons/ic-externalLink';

const ShowingInfoModalTitle: React.FC<{
    content: CachedContentData | undefined;
    showing: ShowingDto;
    isOnContentDetailPage?: boolean;
    /** Renders the title as a semantic `<h1>` instead of a `div`. Only pass this from the canonical
     * showing detail page usage — the modal usage (opened as an overlay on other pages) must keep the
     * default `div` since a modal is not the page's heading context. */
    as?: 'h1' | 'div';
}> = ({ content, showing, isOnContentDetailPage, as = 'div' }) => {
    const locale = useLocale();
    const formatter = useFormat();

    const subtitle = formatter.dateTime.formatDateTimeLong(showing.startDatetime);

    const showingName = showing.name || content?.title;

    const TitleElement = as;

    return (
        <div className="grow">
            <TitleElement
                className="px-8 relative text-headline-18"
                style={{ maxWidth: !isOnContentDetailPage ? 'calc(100% - 38px)' : '100%' }}>
                {showingName}
                {!isOnContentDetailPage && (
                    <Link
                        href={`/program/${showing.contentId}`}
                        locale={locale}
                        className="ml-2.5 align-text-bottom absolute">
                        <IconExternalLink16 className="inline" />
                    </Link>
                )}
            </TitleElement>
            <div className="px-8 text-body-bold-14 text-[var(--on-background-color)]">{subtitle}</div>
        </div>
    );
};

export default ShowingInfoModalTitle;
